<script lang="ts">
    import { modalManagerToken } from "@/tokens";
    import { SPACE_TAB_LIST } from "@apps/iloom_customization/constants/constants";
    import DesignFeedMasonry from "@apps/iloom_customization/design_feed/components/DesignFeedMasonry.svelte";
    import DesignFeedModal from "@apps/iloom_customization/design_feed/components/DesignFeedModal/DesignFeedModal.svelte";
    import DesignFeedTabs from "@apps/iloom_customization/design_feed/components/DesignFeedTabs.svelte";
    import { MediaListQuery } from "@apps/iloom_customization/design_feed/queries/MediaListQuery";
    import { DesignFeedService } from "@apps/iloom_customization/design_feed/services/DesignFeedService";
    import { ProductQuery } from "@apps/iloom_customization/modules/products/queries/ProductQuery";
    import { ProductService } from "@apps/iloom_customization/modules/products/services/ProductService";
    import { WishlistService } from "@apps/iloom_customization/wishlist/services/WishlistService";
    import { hasNextPage } from "@apps/instagram/utils/paginationUtils";
    import { WishlistProductStatusesQuery } from "@apps/wishlist/queries/WishlistProductStatusesQuery";
    import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
    import { CartQuery } from "@modules/cart/queries/CartQuery";
    import { CartService } from "@modules/cart/services/CartService";
    import { lastValueFrom } from "rxjs";
    import { map } from "rxjs/operators";
    import { onMount } from "svelte";
    import { container } from "tsyringe";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Portal from "@components/Portal/Portal.svelte";
    import TabsManager from "@components/Tabs/TabsManager";

    export let cartQuery: CartQuery;
    export let cartService: CartService;
    export let designFeedService: DesignFeedService;
    export let mediaListQuery: MediaListQuery;
    export let productQuery: ProductQuery;
    export let productService: ProductService;
    export let tabsManager: TabsManager;
    export let wishlistService: WishlistService;
    export let wishlistsService: WishlistsService;
    export let wishlistProductStatusesQuery: WishlistProductStatusesQuery;

    const modalManager = container.resolve(modalManagerToken);

    const openedTab$ = tabsManager.openedTab$;

    const mediaListMeta$ = mediaListQuery.meta$;

    const hasNextPage$ = mediaListMeta$.pipe(
        map((meta) => {
            return hasNextPage(meta.limit, meta.offset, meta.total);
        })
    );

    const getMediaList = (offset = 0) => {
        if ($openedTab$) {
            const params = {
                offset,
                collections: $openedTab$ === "all" ? undefined : [$openedTab$],
                limit: $mediaListMeta$.limit,
            };
            lastValueFrom(designFeedService.getMediaList(params));
        }
    };

    const goToDesignFeedPage = () => {
        window.location.href = "/pages/design-feed";
    };

    onMount(() => {
        tabsManager.openTab("all");

        const changeTabSubscription = openedTab$.subscribe(() => {
            getMediaList();
        });

        return () => changeTabSubscription.unsubscribe();
    });
</script>

<div class="gw-df-page">
    <div class="gw-df-page-title">設計摘要</div>
    <DesignFeedTabs {tabsManager} tabs={SPACE_TAB_LIST} />
    <DesignFeedMasonry {modalManager} {designFeedService} {mediaListQuery} />
    {#if $hasNextPage$}
        <div class="gw-df-explore-more-wrapper">
            <BaseButton
                class="gw-df-explore-more"
                on:click={goToDesignFeedPage}
            >
                Explore More
            </BaseButton>
        </div>
    {/if}
</div>

<Portal
    Component={DesignFeedModal}
    componentProps={{
        cartQuery,
        cartService,
        designFeedService,
        mediaListQuery,
        modalManager,
        productQuery,
        productService,
        wishlistService,
        wishlistsService,
        wishlistProductStatusesQuery,
    }}
    selector="body"
/>

<style lang="postcss">
    .gw-df-page-title {
        font-size: 30px;
        margin-bottom: 54px;
        font-weight: 600;
        text-align: center;
        color: #3c3c3c;
    }
    .gw-df-explore-more-wrapper {
        width: 100%;
        text-align: center;
    }
    :global(.gw-btn.gw-df-explore-more) {
        height: 48px;
        padding: 12px 32px 12px 32px;
        border: 1px solid #3c3c3c;
        border-radius: 0;
        transition: all 0.3s ease;
    }
    :global(.gw-btn.gw-df-explore-more:hover) {
        background-color: #3c3c3c;
        color: #ffffff;
    }
    @media (max-width: 600px) {
        :global(.gw-btn.gw-df-explore-more) {
            height: 40px;
            padding: 7px 28px 7px 28px;
        }
    }
</style>
